import {Component, EventEmitter, OnInit, Output} from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { ApiServiceService } from "../../../Services/api-service.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { environment } from "src/environments/environment";
import alertify from "alertifyjs";
import { finalize } from "rxjs";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { RemitaPaymentService } from "../../../Services/RemitaPaymentService";
import { ToastService } from "../../../Services/ToastService";
import { InvoiceValidationModalComponent } from "../invoice-validation-modal/invoice-validation-modal.component";
import {RemitaRespondse} from "../../../models/remiteResponse.model";
import {ScriptService} from "../../../Services/script-service.service";

declare const RmPaymentEngine: any;
@Component({
  selector: 'app-asin-payment-page',
  templateUrl: './asin-payment-page.component.html',
  styleUrls: ['./asin-payment-page.component.css'],
})
export class AsinPaymentPageComponent implements OnInit {
  verifyForm: FormGroup;
  invoiceValidationForm: FormGroup;
  invoicePaymentForm: FormGroup;

  mdaExtendedRevenue: any[] = [];
  mdaList: any[] = [];
  mdaRecord: any = {};
  invoiceRecord: any = {};
  asinDetails: any;
  isLoading: boolean = false;
  errorMessage: any;
  amount: number = 0;
  isVerifyingAsin: boolean = false;
  showAsinVerificationSuccessMessage: boolean;
  paymentType: string;
  invoiceDetailsProcessed: boolean = false;
  paymentMethod: string = 'interswitch';
  isSubmitting: boolean;
  merchantCode = environment.merchantCode;
  payItemId = environment.payItemId;
  interSwitchMode = environment.interSwitchMode;
  remita: RemitaRespondse | any;

  constructor(
    private modalService: BsModalService,
    private fb: FormBuilder,
    private apiService: ApiServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private remitaPaymentService: RemitaPaymentService,
    private spinner: ToastService,
    public modalRef: BsModalRef,
    private scriptService: ScriptService,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.paymentType = params.get("paymentType");
    });
    this.verifyForm = this.fb.group({
      emailOrPhone: ["", [Validators.required, this.emailOrPhoneValidator()]],
      amount: ["", [Validators.required, Validators.min(1)]],
      asin: ["", [Validators.required]],
      mdaId: [null, [Validators.required]],
      revenueId: [null],
      revenueCode: [null, [Validators.required]],
      paymentMethod: [""]

    });

    this.getMdaList();

    if (this.paymentType == "invoice") {
      this.invoiceValidationForm = this.fb.group({
        invoiceNumber: ["", [Validators.required]],
      });

      this.invoicePaymentForm = this.fb.group({
        invoiceNumber: [{ value: "", disabled: true }, [Validators.required]],
        asin: [{ value: "", disabled: true }, [Validators.required, Validators.min(1)]],
        name: [{ value: "", disabled: true }, [Validators.required]],
        mda: [{ value: "", disabled: true }],
        revenueCode: [{ value: "", disabled: true }],
        amount: [{ value: "", disabled: true }],
        dateCreated: [{ value: "", disabled: true }],

      });
      this.openVerificationModal()

    }

  }

   emailOrPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
  
      if (!value) {
        return null; 
      }
  
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
      const phoneRegex = /^(?:\+234|234|0)[789]\d{9}$/; 
  
      const isValidEmail = emailRegex.test(value);
      const isValidPhone = phoneRegex.test(value);
  
      return isValidEmail || isValidPhone ? null : { invalidContact: true };
    };
  }

  get asinControl() {
    return this.verifyForm.get("asin");
  }

  get invoiceNumberControl() {
    return this.invoiceValidationForm.get("invoiceNumber");
  }

  verifyAsin() {
    this.isVerifyingAsin = true;
    this.showAsinVerificationSuccessMessage = false;
    const url = "/assessments/get/asin?asin=" + this.verifyForm.value.asin;
    this.apiService
      .post(url, {})
      .pipe(
        finalize(() => {
          this.isVerifyingAsin = false;
        })
      )
      .subscribe({
        next: (asinData: any) => {
          if (asinData) {
            this.showAsinVerificationSuccessMessage = true;
          } else {
            this.verifyForm.get("asin").setErrors({ invalidASIN: true });
          }
        },
        error: (errors: any) => {
          this.verifyForm.get("asin").setErrors({ invalidASIN: true });
        },
      });
  }

  back () {
    this.router.navigate(['/'])
  }

  openVerificationModal() {
    let bsModalRef = this.modalService.show(InvoiceValidationModalComponent, {
      class: 'modal-md modal-dialog-centered ',
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      initialState: {
        callback: (res: any) => {
          if(res.success) {
            this.invoiceRecord = res;
            this.invoiceDetailsProcessed = true;
            this.isVerifyingAsin = false;
  
            this.invoicePaymentForm.patchValue({
              invoiceNumber: res?.data?.data?.invoiceDetails?.invoiceNumber,
              asin: res?.data?.data?.invoiceDetails?.asin,
              name: res?.data?.data?.invoiceDetails?.taxpayerName,
              mda: res?.data?.data?.invoiceDetails?.mdaName,
              revenueCode: res?.data?.data?.invoiceDetails?.revenueCode,
              amount: res?.data?.data?.invoiceDetails?.invoiceAmount,
              dateCreated: res?.data?.data?.invoiceDetails?.dateCreated,
            });
  
            this.isLoading = false;
            this.amount = res?.data?.data?.invoiceDetails?.invoiceAmount;
            bsModalRef.hide()
          }else{
            this.invoiceDetailsProcessed = false;
            this.isVerifyingAsin = false;
            alertify.set("notifier", "position", "top-center");
            alertify.error("Invalid Invoice Number/Invoice Already Paid");
            this.isLoading = false;
            this.errorMessage = res.message;
            bsModalRef.hide();
          }
        }
      }
    });

  }

  getMdaRevenue(id: any) {
    const url = `/api/payment/split-account/all/revenues?id=${this.verifyForm.value.mdaId}`;
    this.apiService.PaymentGet(url).subscribe(
      (response) => {
        this.mdaExtendedRevenue = response.map((item: any) => ({
          ...item,
          description: item.description
            .toLowerCase()
            .replace(/\b\w/g, (char: any) => char.toUpperCase())
        }));;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMdaList() {
    const url = "/api/payment/split-account/all/mda/list";
    this.apiService.PaymentGet(url).subscribe(
      (response) => {
        this.mdaList = response.map((item: any) => ({
          ...item,
          description: item.description
            .toLowerCase()
            .replace(/\b\w/g, (char: any) => char.toUpperCase())
        }));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getMdaRecord(id: any) {
    this.mdaRecord = id;
  }

  isSubmittingAsinPayment: boolean;
  submit() {
    this.isSubmittingAsinPayment = true;
    const returnBackUrl = environment.url + "/payment/successful-payment";
    var details = {
      returnBackUrl: returnBackUrl,
      totalAmount: Number(this.verifyForm.value.amount.split(",").join("")),
      fullName: this.asinDetails.displayname,
      customerId: this.asinDetails.tinNumber,
      revenueName: this.mdaRecord.description,
      revenueId: this.mdaRecord.revenueCode,
      emailOrPhone: this.verifyForm.value.emailOrPhone,
      taxGroup: "INDIVIDUAL",
      feeDescription: this.mdaRecord.description,
      entityName: this.mdaRecord.description,
      phoneNumber: this.verifyForm.value.phoneNumber,
      entityType: "NON MDA",
      entityGroup: "FLAT",
      accessedBy: this.asinDetails.displayname,
      mdaRecordId: this.mdaRecord?.id,
    };

    if (this.paymentMethod == 'interswitch') {
      this.isSubmitting = true;
      this.startInterswitch(details);
    }else if (this.paymentMethod == 'remita'){
      const details = {
        amount:Number(this.verifyForm.value.amount.split(",").join("")),
        serviceTypeId:this.mdaRecord?.id,
        payerName:this.asinDetails.displayname,
        payerEmail:this.verifyForm.value.emailOrPhone,
        payerPhone:this.verifyForm.value.emailOrPhone,
        revenueId:this.mdaRecord?.id,
        tin: this.asinDetails.tinNumber,
      }
      this.startRemita(details);
    } else {
      this.isSubmitting = false;
      this.isSubmittingAsinPayment = false;
      alertify.set("notifier", "position", "top-center");
      alertify.error("Payment Gateway not available");
    }
  }

  isSubmittingInvoicePayment: boolean;
  submitInvoicePayment() {
    this.isSubmittingInvoicePayment = true;
  }

  clearInvoiceDetials() {
    this.invoiceDetailsProcessed = false;
    this.invoicePaymentForm.reset()
    this.openVerificationModal()
  }

  userDetailsValidated: boolean;


  validateUser() {
    this.userDetailsValidated = false;
    const url = "/assessments/get/asin/" + this.verifyForm.value.asin;
    this.apiService.post(url, {}).subscribe(
      (res) => {
        if (res == null) {
          alertify.set("notifier", "position", "top-center");
          alertify.error("Invalid ASIN Number");
          return;
        }
        this.userDetailsValidated = true;
        this.asinDetails = res;
        this.isLoading = false;
        this.amount = this.verifyForm.value.amount.split(",").join("");
      },
      (error) => {
        alertify.set("notifier", "position", "top-center");
        alertify.error("Invalid ASIN Number");
        this.isLoading = false;
        this.errorMessage = error.error.message;
      }
    );
  }

  clear() {
    this.asinDetails = null;
    this.amount = 0;
  }

  getType(e: any) {
    this.paymentMethod = e.target.value;
  }


  startInterswitch(details: any) {
    this.spinner.spin()
    this.remitaPaymentService.startInterswitchInline(details).subscribe(
      response => {
        this.spinner.hide();
        this.isSubmitting = false;
        this.scriptService.loadScript('switch_inline').then(r => {
          this.checkout(details, response);
        });

      },
      error => {
        this.isSubmitting = false;
        console.info(`Remita Generate RRR error: ${error}`);
      });
  }

  checkout(details: any, interswitch: any) {
    var paymentRequest = {
      merchant_code: this.merchantCode,
      pay_item_id: this.payItemId,
      txn_ref: interswitch.orderId,
      cust_id: details.customerId,
      amount: Math.round((details?.totalAmount * 100 + Number.EPSILON) * 100) / 100,
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: (response: any) => {
        this.paymentCallback(response);
      },
      mode: this.interSwitchMode,
      split_accounts: this.interSwitchMode == "LIVE" && !interswitch?.splitAccounts?.isEmpty ? JSON.stringify(interswitch?.splitAccounts) : ""
    };
    (window as any).webpayCheckout(paymentRequest);
  }
  paymentCallback(response: any) {
    this.isSubmittingAsinPayment = false;
    if (response != null && response.desc == "Approved by Financial Institution") {
      sessionStorage.setItem('interResponse', JSON.stringify(response));
      setTimeout(() => {
        window.open("/payment/return-back/" + response.txnref
          + "/" + 0.0, "_self")
      }, 50);
    }
    // if (response.txnref != null) {
    //   setTimeout(() => {
    //     window.open("/payment/return-back/" + response.txnref, "_self")
    //   }, 50);
    // }
  }

  processInvoiceDetials() {
    this.userDetailsValidated = false;
    this.isVerifyingAsin = true;
    const url = "/assessments/pay/invoice?invoiceNumber=" + this.invoiceValidationForm.value.invoiceNumber;
    this.apiService.get(url, {}).subscribe(
      (res) => {
        this.invoiceRecord = res;
        this.invoiceDetailsProcessed = true;
        this.isVerifyingAsin = false;
        this.invoicePaymentForm.patchValue({
          invoiceNumber: res?.data?.data?.invoiceDetails?.invoiceNumber,
          asin: res?.data?.data?.invoiceDetails?.asin,
          name: res?.data?.data?.invoiceDetails?.taxpayerName,
          mda: res?.data?.data?.invoiceDetails?.mdaName,
          revenueCode: res?.data?.data?.invoiceDetails?.revenueCode,
          amount: res?.data?.data?.invoiceDetails?.invoiceAmount,
          dateCreated: res?.data?.data?.invoiceDetails?.dateCreated,
        })
        this.isLoading = false;
        this.amount = res?.data?.data?.invoiceDetails?.invoiceAmount;
      },
      (error) => {
        this.invoiceDetailsProcessed = true;
        this.isVerifyingAsin = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Invalid Invoice Number/Invoice Already Paid");
        this.invoiceDetailsProcessed = false;
        this.isLoading = false;
        this.errorMessage = error.error.message;
      }
    );
  }

  submitInvoice() {
    this.isSubmittingInvoicePayment = true;
    const returnBackUrl = environment.url + "/payment/successful-payment";
    var details = {
      returnBackUrl: returnBackUrl,
      totalAmount: this.invoiceRecord?.data?.data?.invoiceDetails?.invoiceAmount,
      customerId: this.invoiceRecord?.data?.data?.invoiceDetails?.asin,
    };

    var interswitch = {
      totalAmount: this.invoiceRecord?.data?.data?.invoiceDetails?.invoiceAmount,
      customerId: this.invoiceRecord?.data?.data?.invoiceDetails?.asin,
      splitAccounts: this.invoiceRecord?.data?.data?.paymentDetails?.splitAccounts,
      orderId: this.invoiceRecord?.data?.data?.paymentDetails?.orderId
    }

    if (this.paymentMethod == 'interswitch') {
      this.isSubmitting = true;
      this.checkout(details, interswitch);
    } else {
      this.isSubmittingInvoicePayment = false;
      alertify.set("notifier", "position", "top-center");
      alertify.error("Payment Gateway not available");
    }
  }

  startRemita(details?: any) {
    this.scriptService.loadScript('remita_inline').then(r => {
      this.generateRRR(details);
    });
  }

  generateRRR(details:any) {
    this.remitaPaymentService.generateRemitaRRR(details).subscribe(value => {
    this.isSubmittingAsinPayment = false;
      this.remita = value;
      this.loadRemitaIframe(this.remita)
    }, error => {
        this.isSubmittingAsinPayment = false;
      this.spinner.hide();
    })
  }


  loadRemitaIframe(remita: any): void {
    if (!remita) {
      return;
    }
    const paymentEngine = RmPaymentEngine.init({
      key: environment.remitaInLineKey,
      processRrr: true,
      transactionId: remita.orderId,
      extendedData: {
        autofill: true,
        customFields: [
          {
            name: 'rrr',
            value: remita.rrr
          }
        ]
      },
      onSuccess: (response: any) => {
        const order = {
          orderId: remita.orderId,
          rrr: response.paymentReference,
          paymentReference: response.paymentReference,
          transactionId: response.transactionId,
          amount: remita.amount,
          responseurl: remita.responseurl
        }
        this.remitaPaymentService.acknowledgementRRR(order).subscribe(
            response => {
              this.isSubmittingAsinPayment = false;
              // if (response.message =="Successful") {
                alertify.set("notifier", "position", "top-center");
                alertify.success("Payment Successful");
                setTimeout(() => {
                  window.open("/payment/return-back/" + remita.rrr + "/" + remita.amount, "_self")
                }, 50);
              // } else {
              //   alertify.set("notifier", "position", "top-center");
              //   alertify.error(response.message);
              // }
            },
            error => {
              setTimeout(() => {
              alertify.set("notifier", "position", "top-center");
              alertify.error(response.message);
                this.close();
              }, 50);

            });
      },
      onError: (response: any) => {
        setTimeout(() => {
          document.getElementById('closeRemitaPop')?.click()
        }, 3000);
        // this.openDialog(remita, invoice, false, index);
      },
      onClose: () => {
      }
    });
    paymentEngine.showPaymentWidget();
  }

  @Output() onConfirmClicked = new EventEmitter();
  close() {
    this.onConfirmClicked.emit();
    this.modalRef.hide();
  }
}
